import { useDispatch } from 'react-redux';
import { notMyBusinessAnymore } from 'shared/consts';
import { push } from 'connected-react-router';

export const useBetaVersionRedirect = () => {
  const dispatch = useDispatch();

  return (path: string) => {
    if (notMyBusinessAnymore.some((regexp) => regexp.test(path))) {
      window.location.href = path;
      return;
    }
    dispatch(push(path));
  };
};
